module.exports = __webpack_public_path__ + "img/acm.9e9e2f62.png";